/**
 * Archivo: recargo-checkout-button.js
 * Propósito: Manejar click del botón "Realizar pedido" con protección ante caídas del servidor.
 */

(function() {
  'use strict';
  
  const DEBUG_MODE = true; // Activado para verificar la protección
  const API_ENDPOINT = '/apps/recargo/create-draft-order';
  let isProcessing = false;
  
  function debugLog(message, data) {
    if (DEBUG_MODE) console.log(`[Recargo Checkout] ${message}`, data || '');
  }

  /**
   * Maneja el click en "Realizar pedido"
   */
  async function handleRecargoCheckout(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing) return;
    
    const button = e.target;
    const originalText = button.textContent;

    try {
      isProcessing = true;
      
      // Estado Visual de Carga
      button.disabled = true;
      button.textContent = 'Verificando sistema...';
      button.style.opacity = '0.6';

      // 1. Obtener carrito
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) throw new Error('No se pudo obtener el carrito.');
      const cart = await cartResponse.json();
      
      if (cart.items.length === 0) throw new Error('El carrito está vacío.');

      // 2. Intentar crear Draft Order con TIMEOUT
      button.textContent = 'Creando pedido oficial...';
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 segundos de espera máx.

      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({ 
          cartToken: cart.token,
          cart: cart
        })
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        // Si el servidor devuelve 404 o 500, el App Proxy está fallando
        throw new Error('SERVIDOR_OFFLINE');
      }
      
      const data = await response.json();
      
      if (!data.success || !data.draft_order?.invoice_url) {
        throw new Error('RESPUESTA_INVALIDA');
      }
      
      button.textContent = '✓ Redirigiendo al pago...';
      button.style.backgroundColor = '#28a745';
      
      window.location.href = data.draft_order.invoice_url;
      
    } catch (error) {
      console.error('❌ Error crítico en checkout de recargo:', error);
      
      // Restaurar botón
      button.disabled = false;
      button.textContent = originalText;
      button.style.opacity = '1';

      // Mensaje personalizado según el error
      if (error.name === 'AbortError' || error.message === 'SERVIDOR_OFFLINE') {
        alert("⚠️ SISTEMA TEMPORALMENTE NO DISPONIBLE\n\nNuestro servicio de facturación profesional para recargo de equivalencia está en mantenimiento.\n\nPor favor, inténtelo de nuevo en 5 minutos o contacte con nosotros si el problema persiste.");
      } else {
        alert(`No se pudo procesar el pedido: ${error.message}`);
      }
    } finally {
      isProcessing = false;
    }
  }
  
  function initialize() {
    const button = document.getElementById('recargo-checkout-button');
    if (!button || button.dataset.handlerAttached) return;
    
    button.addEventListener('click', handleRecargoCheckout);
    button.dataset.handlerAttached = 'true';
    debugLog('✅ Botón detectado y protegido.');
  }
  
  // Inicialización multi-evento
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(initialize, 500));
  } else {
    setTimeout(initialize, 500);
  }

  document.addEventListener('cart:updated', () => setTimeout(initialize, 300));
})();